import * as React from 'react';
import * as _ from 'lodash';
import * as moment from 'moment';
import * as qs from 'query-string';
import { Dispatch, connect } from 'react-redux';
import { AppActionCreators, IApplicationState, ILateSerologiesReportResponse, ReportActionCreators } from '@nkr/store/index';
import { ILateSerology } from '@nkr/models/index';
import { TableWrapper } from './styles';
import { Button, FormControl, Well } from 'react-bootstrap';
import { Utility } from '@nkr/services/utility';

interface IOwnProps {
    centerId: number,
    isCenterLogin: boolean
}

interface IStateProps { }

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getLateSerologiesReport: (centerId: number, startDate: string) => Promise<ILateSerologiesReportResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps

interface IState {
    list: ILateSerology[],
    startDate: string,
    centerId: number
}

const getStartDate = () => {
    let parsed = qs.parse(location.search);
    let startDate = moment(parsed?.sd, 'YYYY-MM-DD', true);

    return startDate.isValid() ? startDate.date(1).format('YYYY-MM-DD') : moment().date(1).format('YYYY-MM-DD');
}

class LateSerologiesReport extends React.Component<TProps, IState> {
    readonly state: IState = {
        list: [],
        startDate: getStartDate(),
        centerId: 0
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading('Getting report, one moment please...').then(() => {
            this.props.getLateSerologiesReport(this.props.centerId, this.state.startDate).then(response => {
                this.props.hideLoading();

                if (response.data.success) {
                    this.setState({
                        list: response.data.results
                    });
                }
            });
        });
    }

    getCenterList = () => {
        let list = this.state.list.map(x => {
            return { id: x.donorCenterId, alias: x.donorCenterAlias };
        });

        let centers = _.uniqBy(list, item => item.id);

        return _.sortBy(centers, item => item.alias);
    }

    getFilteredList = () => {
        return this.state.list.filter(x => {
            let centerFilter = this.state.centerId > 0 ? x.donorCenterId == this.state.centerId : true;

            return centerFilter;
        });
    }

    handleDateChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            startDate: e.currentTarget.value
        }, () => {
            this.getData();
        });
    }

    handleCenterChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            centerId: parseInt(e.currentTarget.value)
        });
    }

    handleExport = () => {
        let currentMonth = moment(this.state.startDate)
        let monthYear = currentMonth.format('MM-YYYY')

        let data = this.state.list;

        let csvContent = 'data:text/csv;charset=utf-8,'
            + 'Donor Center,Donor Alias,Upload Date,Surgery Date,Received VRL,Days Late,Upload By,Kidney Pickup\n'
            + data.map(e => e.donorCenterAlias
                + ',' + e.donorAlias
                + ',' + e.uploadDate
                + ',' + e.surgeryDate
                + ',' + e.receivedVrl
                + ',' + e.daysLate
                + ',' + e.uploadBy
                + ',' + e.kidneyPickupDateTime).join('\n');

        let encodedUri = encodeURI(csvContent);

        let link = document.createElement('a');

        link.setAttribute('href', encodedUri);
        link.setAttribute('download', 'late-serologies_' + monthYear + '.csv');

        document.body.appendChild(link);

        link.click();
    }

    render = () => {
        const centerList = this.getCenterList();
        const filteredList = this.getFilteredList();
        const dateList = Utility.getRange(moment().subtract(11, 'month'), moment().add(1, 'month'), 'month').map(d => d.date(1));

        return (
            <div style={{ minHeight: 500 }}>
                {this.props.isCenterLogin == false && (
                    <div style={{ marginBottom: 20, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ fontSize: 28, fontWeight: 500 }}>Serology results uploaded less than three (3) days before donor surgery</div>
                    </div>
                )}

                <Well bsSize='sm' style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div style={{ display: 'flex', fontSize: 12 }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{ marginRight: 5 }}>Filter by Month:</div>
                            <div style={{ marginRight: 20 }}>
                                <FormControl
                                    componentClass='select'
                                    bsSize='sm'
                                    value={this.state.startDate}
                                    onChange={this.handleDateChange}>
                                    {dateList.map(date =>
                                        <option key={`ctr-${date.format('YYYY-MM-DD')}`} value={date.format('YYYY-MM-DD')}>{date.format('MM/YYYY')}</option>
                                    )}
                                </FormControl>
                            </div>
                        </div>

                        {this.props.isCenterLogin == false && (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <div style={{ marginRight: 5 }}>Filter by Center:</div>
                                <div style={{ marginRight: 20 }}>
                                    <FormControl
                                        componentClass='select'
                                        bsSize='sm'
                                        value={this.state.centerId}
                                        onChange={this.handleCenterChange}>
                                        <option value={0}>- All Centers -</option>
                                        {centerList.map(center =>
                                            <option key={`ctr-${center.id}`} value={center.id}>{center.alias}</option>
                                        )}
                                    </FormControl>
                                </div>
                            </div>
                        )}
                    </div>

                    <div>
                        <Button bsSize='sm' onClick={this.handleExport}>Export to CSV</Button>
                    </div>
                </Well>

                <TableWrapper condensed striped>
                    <thead>
                        <tr>
                            <th>Donor Center</th>
                            <th>Donor Alias</th>
                            <th>Upload Date</th>
                            <th>Surgery Date</th>
                            <th>Received VRL</th>
                            <th>Days Late</th>
                            <th>Upload By</th>
                            <th>Kidney Pickup Date/Time</th>
                            {/* <th>Most Recent Offer</th> */}
                        </tr>
                    </thead>
                    <tbody>
                        {filteredList.map((item, index) =>
                            <tr key={'rexm-' + index}>
                                <td>{item.donorCenterAlias}</td>
                                <td>{item.donorAlias}</td>
                                <td>{item.uploadDate}</td>
                                <td>{item.surgeryDate}</td>
                                <td>{item.receivedVrl}</td>
                                <td>{item.daysLate}</td>
                                <td>{item.uploadBy}</td>
                                <td>{item.kidneyPickupDateTime}</td>
                                {/* <td>{item.mostRecentOffer}</td> */}
                            </tr>
                        )}

                        {filteredList.length == 0 && (
                            <tr>
                                <td colSpan={9}>No late serologies found for {moment(this.state.startDate).format('MMMM YYYY')}</td>
                            </tr>
                        )}
                    </tbody>
                </TableWrapper>
            </div>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        // reports: appState.reports
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getLateSerologiesReport: (centerId, startDate) => {
            return dispatch(ReportActionCreators.getLateSerologiesReport(centerId, startDate));
        },
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(LateSerologiesReport);